import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_ALLERGEN,
  FETCH_ALLERGENS,
  RENAME_ALLERGEN,
  REPLACE_ALLERGEN,
  RESET_ALLERGEN_TREE,
  SET_DATA_FOR_RENAMING_ALLERGEN,
} from '../action-types'

export const cleanupFetchAllergens = createAction(FETCH_ALLERGENS.CLEANUP)
export const addAllergen = createPayloadAction(ADD_ALLERGEN)
export const renameAllergen = createPayloadAction(RENAME_ALLERGEN)
export const resetAllergenTree = createAction(RESET_ALLERGEN_TREE)
export const replaceAllergen = createPayloadAction(REPLACE_ALLERGEN)

export const setDataForRenamingAllergen = createPayloadAction(
  SET_DATA_FOR_RENAMING_ALLERGEN,
)
